import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectSelectedBot } from '@/store/chat/selectors';

import PropTypes from 'prop-types';

const ModelSelectionContext = createContext();

export const useModelSelection = () => {
  const context = useContext(ModelSelectionContext);
  if (!context) {
    throw new Error('useModelSelection must be used within a ModelSelectionProvider');
  }
  return context;
};

export const ModelSelectionProvider = ({ children }) => {
  const selectedBot = useSelector(selectSelectedBot);
  const [selectedModelName, setSelectedModelName] = useState(null);
  // Сбрасываем выбранную модель на предпочтительную при смене бота
  useEffect(() => {
    if (selectedBot?.preferredProvider && selectedBot?.available_models) {
      const preferredModel = selectedBot.available_models.find(
        model => model.modelName === selectedBot.preferredProvider
      );
      if (preferredModel) {
        setSelectedModelName(preferredModel.modelName);
        console.log('🤖 Установлена предпочтительная модель бота:', preferredModel.modelName);
      }
    } else if (!selectedBot) {
      // Очищаем выбранную модель если бот не выбран (например, при закрытии чата)
      setSelectedModelName(null);
      console.log('🗑️ Очищена выбранная модель (бот не выбран)');
    }
  }, [selectedBot]);

  const value = {
    selectedModelName,
    setSelectedModelName,
    selectedBot,
  };

  return <ModelSelectionContext.Provider value={value}>{children}</ModelSelectionContext.Provider>;
};

ModelSelectionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModelSelectionContext;
